import { Box, Grid, Typography } from "@mui/material";

type InfoRowProps = {
	value?: string | number | boolean | null;
};

const InfoRow = ({ value }: InfoRowProps) => {
	const displayValue = typeof value === "boolean" ? (value ? "YES" : "NO") : value ?? "N/A";

	return (
		<Typography fontSize={14} fontWeight={600} lineHeight={1.4} color="text.primary">
			{displayValue}
		</Typography>
	);
};

export default InfoRow;
